import { OrderLineRouteService } from 'common/data';
import { findParams } from 'core/utils';
import { BaseService } from 'core/services';

class OrderLineService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new OrderLineRouteService());
	}
	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	linkAllOrderLines(sourceOfChange) {
		var url = this.routeService.linkAllOrderLines(sourceOfChange);
		return this.apiClient.put(url);
	}

	linkOrderLine(linkOrderLineParams,sourceOfChange) {
		var url = this.routeService.linkOrderLine(sourceOfChange);
		return this.apiClient.post(url, linkOrderLineParams);
	}
}

export default OrderLineService;
